import { Directive, ElementRef, OnInit, Renderer2 } from '@angular/core';
import { environment } from 'src/environments/environment';

@Directive({
    selector: '[data-testid]',
    standalone: false
})
export class StripTestIdDirective implements OnInit {
  constructor(private el: ElementRef, private renderer: Renderer2) { }

  ngOnInit(): void {
    if (environment.production) {
      this.renderer.removeAttribute(this.el.nativeElement, 'data-testid');
    }
  }
}

